export default "__VITE_ASSET__CTVU3RCO__"